import { render, staticRenderFns } from "./DocumentsTableAction.vue?vue&type=template&id=4b458f85"
import script from "./DocumentsTableAction.vue?vue&type=script&lang=js"
export * from "./DocumentsTableAction.vue?vue&type=script&lang=js"
import style0 from "./DocumentsTableAction.vue?vue&type=style&index=0&id=4b458f85&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports